import { render, staticRenderFns } from "./goodsDetailsImg.vue?vue&type=template&id=303d02bc&"
import script from "./goodsDetailsImg.vue?vue&type=script&lang=js&"
export * from "./goodsDetailsImg.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetailsImg.vue?vue&type=style&index=0&id=303d02bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports